//
// Module for the User Subscriptions Edit view
//
rs.module("user/subscriptions/edit",

    [ "common/visibility" ],

    function (visibility) {

        // Initialize the module
        function initialize(jsSelectors, distributionMethods, subscriptionId, persistedEventId, persistedAppMessageId, backendUrls) {

            var subscriptionDiv = $.js(jsSelectors.subscriptionDiv);
            var matchParametersDiv = $.js(jsSelectors.matchParametersDiv);

            var eventSelect = subscriptionDiv.js(jsSelectors.eventSelect, { required: false });
            var appMessageSelect = subscriptionDiv.js(jsSelectors.appMessageSelect, { required: false });
            var distChannelSelect = subscriptionDiv.js(jsSelectors.distChannelSelect);
            var emailDiv = subscriptionDiv.js(jsSelectors.emailDiv);
            var alertTextDiv = subscriptionDiv.js(jsSelectors.alertTextDiv);
            var alertTextInput = subscriptionDiv.js(jsSelectors.alertTextInput);
            var loadingSpinner = subscriptionDiv.js(jsSelectors.loadingSpinner);
            var matchParametersContent = matchParametersDiv.js(jsSelectors.matchParametersContent);      

            eventSelect.change(eventChanged);
            appMessageSelect.change(appMessageChanged);
            distChannelSelect.change(distributionMethodChanged);

            // Event selection changed
            function eventChanged() {
                loadingSpinner.show();

                var selectedEventId = eventSelect.val();
                var selectedEventText = eventSelect.find(":selected").text();

                alertTextInput.val(selectedEventText);

                updateMatchParametersForEvent(
                    backendUrls.getMatchParametersForEvent,
                    selectedEventId);
            }

            // App Message selection changed
            function appMessageChanged() {
                loadingSpinner.show();

                var selectedAppMessageId = appMessageSelect.val();

                alertTextInput.val("");

                updateMatchParametersForAppMessage(
                    backendUrls.getMatchParametersForAppMessage,
                    selectedAppMessageId);
            }

            // Distribution Method selection changed
            function distributionMethodChanged() {
                visibility.setVisible(emailDiv, distChannelSelect.val() == distributionMethods.email);
                visibility.setVisible(alertTextDiv, distChannelSelect.val() == distributionMethods.userAlert);
            }

            // Update match parameters for an event from a url with parameters
            function updateMatchParametersForEvent(url, eventId) {
                $.get(url,
                    {
                        subscriptionId: subscriptionId,
                        eventId: eventId,
                        includeExistingMatchParameters: subscriptionId != -1 && eventId == persistedEventId
                    },
                    function done(html) {
                        matchParametersContent.html(html);
                        loadingSpinner.hide();

                        var form = $.js(jsSelectors.form);

                        // Reset validation
                        $.validator.resetValidation(form);
                    }
                );
            }

            // Update match parameters for an event from a url with parameters
            function updateMatchParametersForAppMessage(url, appMessageId) {
                $.get(url,
                    {
                        subscriptionId: subscriptionId,
                        appMessageId: appMessageId,
                        includeExistingMatchParameters: subscriptionId != -1 && appMessageId == persistedAppMessageId
                    },
                    function done(html) {
                        matchParametersContent.html(html);
                        loadingSpinner.hide();

                        var form = $.js(jsSelectors.form);

                        // Reset validation
                        $.validator.resetValidation(form);
                    }
                );
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);